module.exports = __webpack_public_path__ + "static/img/shiwu.dafc7a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shiwu.png
// module id = 47Bu
// module chunks = 1